export enum AgeType {
	ADULT = 'ADULT',
	CHILD = 'CHILD',
	BABY = 'BABY',
}
